import ErrorReportDataTable from '../../../features/system/error-report/components/ErrorReportDataTable'
import ErrorReportFilterHeader from '../../../features/system/error-report/components/ErrorReportFilterHeader'

export default function ErrorReportPage() {
  return (
    <>
      <ErrorReportFilterHeader />
      <ErrorReportDataTable />
    </>
  )
}
